
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import ChatList from "./ChatList";
import ChatWindow from "./ChatWindow";
import MessageInput from "./MessageInput";
import ContactDetails from "./ContactDetails";
import { useLocation } from "react-router-dom";
import {
  loadOldChat,
  setActiveChat,
  markChatRead,
  sendMessage,
  toggleContact,
  startNewChat,
  appendOldMessages,
  setChatMessages,
  clearPendingOpenChat,
} from "../../../../../core/data/redux/slices/WabaChatSlice";
import api from "../../../../../core/axios/axiosInstance";
import { useNavigate } from "react-router-dom";


const Whatsapp = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { conversations, activeChatId, showContact, totalCount } = useSelector(
    state => state.wabaChat
  );

  const [chatPage, setChatPage] = useState(1);
  const [chatLimit, setChatLimit] = useState(10);
  const [readFilter, setReadFilter] = useState("all");
  const [dateRange, setDateRange] = useState([null, null]);

  const [isLoadingMoreMessages, setIsLoadingMoreMessages] = useState(false);
  const [isLoadingMessages, setIsLoadingMessages] = useState(false);
  const messagePagination = useSelector(s => s.wabaChat.messagePagination);
  const activePagination = activeChatId ? messagePagination[activeChatId] : null;


  const userProfile = useSelector((state) => state.profile);


  const [isLoadingChats, setIsLoadingChats] = useState(true);




  const activeChatName = useSelector((state) => {
    const { conversations, activeChatId } = state.wabaChat;


    const chat = conversations.find(c => c.from === activeChatId);
    return (
      chat?.name ||
      chat?.messages?.find(msg => msg.name)?.name ||
      chat?.from ||
      "Unknown"
    );
  });



  // Add this function inside Whatsapp component
  const fetchMessages = async (chatId, page = 1) => {
    try {
      const response = await api.post("/api/whatsapp/messages", {
        chatNumber: chatId,
        messagePage: String(page),
        messagePageLimit: 20,
        messageSearch: "",
      });
      console.log(response.data, "response from msgs");

      const raw = response.data.data;
      const pagination = response.data.pagination;

const messages = raw.map((msg) => {
        const type = msg.messageType || "text";
        let text, media, location, contacts, template;

        if (type === "text") {
          text = typeof msg.content?.text === "string"
            ? msg.content.text
            : msg.content?.text?.body || "";
        }

        if (["image", "video", "audio", "document"].includes(type)) {
          media = {
            url: msg.s3dataurl || msg.content?.mediaUrl || "",
            mimeType: msg.content?.mimeType || msg.content?.mime_type,
            attachmentName: msg.attachmentName || msg.content?.fileName || "Attachment",
            attachmentCaption: msg.content?.caption || "",
          };
        }

        if (type === "location") {
          location = {
            latitude: msg.content?.latitude,
            longitude: msg.content?.longitude,
            name: msg.content?.name || "",
            address: msg.content?.address || "",
          };
        }

        if (type === "contacts") {
          contacts = Array.isArray(msg.content?.contacts)
            ? msg.content.contacts.map((c) => ({
              name: c.name?.formatted_name || c.name?.first_name || "Unknown",
              phones: c.phones || [],
            }))
            : [];
        }

        if (type === "button") {
          console.log("[fetchMessages:button] Quick reply msg from DB:", JSON.stringify({ id: msg._id, content: msg.content, direction: msg.direction }));
          text = msg.content?.buttonText || "";
        }

        let interactive;
        let flowResponseData;
        if (type === "interactive") {
          if (msg.content?.interactive) {
            // Outgoing automation message — full interactive structure
            interactive = msg.content.interactive;
            const bodyContent = msg.content.interactive?.body;
            text = msg.content.text || (typeof bodyContent === "string" ? bodyContent : bodyContent?.text) || "";
          } else if (msg.content?.interactiveType === "nfm_reply") {
            // WhatsApp Flow submission from user
            interactive = { type: "nfm_reply" };
            text = msg.content.flowName || "Form submitted";
            flowResponseData = msg.content.flowResponseData || {};
          } else {
            // Incoming user selection (list_reply / button_reply) — just show what they picked
            text = msg.content?.interactiveTitle || "";
            interactive = null;
          }
          console.log("[fetchMessages:interactive] id:", msg._id, "dir:", msg.direction,
            "iType:", interactive?.type, "body:", JSON.stringify(interactive?.body),
            "action:", JSON.stringify(interactive?.action), "text:", text);
        }

        if (type === "template") {
          const tplContent = msg.content?.template;
          // Backend automation saves empty components — extract name from content.text "[Template: name]"
          const nameFromText = msg.content?.text?.match(/^\[Template:\s*(.+)\]$/)?.[1];
          const tplName = tplContent?.name || nameFromText;
          if (tplContent || tplName) {
            template = {
              name: tplName,
              language: tplContent?.language,
              components: tplContent?.components,
              resolved: tplContent?.resolved,
            };
            text =
              template.resolved?.body ||
              template.components
                ?.filter((c) => c.type === "BODY" || c.type === "body")
                .map((c) => c.text)
                .join("\n");
          }
          console.log("[fetchMessages:template] id:", msg._id, "dir:", msg.direction,
            "name:", template?.name, "components:", template?.components?.length ?? 0,
            "text:", text, "nameFromText:", nameFromText);
        }

        if (!["text","image","video","audio","document","location","contacts","button","interactive","template"].includes(type)) {
          console.warn("[fetchMessages:UNKNOWN_TYPE] id:", msg._id, "type:", type, "content:", JSON.stringify(msg.content));
        }

        const buttonReply = type === "button"
          ? { text: msg.content?.buttonText || "", payload: msg.content?.buttonPayload || "" }
          : undefined;

        return {
          id: msg._id,
          from: msg.direction === "incoming" ? "user" : "agent",
          type,
          text,
          media,
          location,
          contacts,
          template,
          interactive,
          flowResponseData,
          flowName: type === "interactive" && msg.content?.interactiveType === "nfm_reply"
            ? (msg.content.flowName || null)
            : undefined,
          buttonReply,
          name: msg.senderName,
          status: msg.direction === "outgoing" ? msg.status || "sent" : undefined,
          metaMessageId: msg.metaMessageId || undefined,
          timestamp: msg.messageTimestamp || msg.messageSentTimestamp || msg.createdAt || null,
          date: (() => {
            const ts = msg.messageTimestamp || msg.messageSentTimestamp || msg.createdAt;
            return ts ? new Date(ts).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "";
          })(),
          time: (() => {
            const ts = msg.messageTimestamp || msg.messageSentTimestamp || msg.createdAt;
            return ts ? new Date(ts).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : "";
          })(),
        };
      });

      return { messages, pagination };
    } catch (err) {
      console.error("Failed to fetch messages", err);
      return null;
    }
  };

  const [showPreview, setShowPreview] = useState(false);

  const activeChat = conversations.find(c => c.id === activeChatId);


  const isWhatsappConnected =
    userProfile?.accounts?.whatsapp?.isConnected;

  const isHistoryPage =
    location.pathname === "/whatsapp/history" ||
    location.pathname === "/agent/whatsapp/history" ||
    location.pathname === "/admin/whatsapp/history";


  const filteredConversations = conversations.filter(
    (chat) => chat.isHistory === isHistoryPage
  );

  const handleLoadMore = async () => {
    if (!activeChatId || !activePagination?.hasMore) return;
    setIsLoadingMoreMessages(true);
    const nextPage = activePagination.currentPage + 1;
    const result = await fetchMessages(activeChatId, nextPage);
    if (result) {
      dispatch(appendOldMessages({
        chatId: activeChatId,
        messages: result.messages,
        pagination: result.pagination,
      }));
    }
    setIsLoadingMoreMessages(false);
  };


  useEffect(() => {
    if (isWhatsappConnected === false) return;

    const fetchWabaChat = async () => {
      try {
        setIsLoadingChats(true);

        const payload = {
          type: isHistoryPage ? "history" : "chats",
          page: chatPage,
          limit: chatLimit,
          search: "",
          readFilter,
          ...(isHistoryPage && dateRange[0] && dateRange[1] && {
            dateFrom: dateRange[0].startOf("day").toISOString(),
            dateTo: dateRange[1].endOf("day").toISOString(),
          }),
        };

        const response = await api.post(
          "/api/whatsapp/conversations",
          payload
        );


        dispatch(
          loadOldChat({
            data: response.data.data,
            totalCount: response.data.totalCount,
          })
        );


      } catch (error) {
        console.error("Failed to fetch WhatsApp chats", error);
      } finally {
        setIsLoadingChats(false);
      }
    };

    fetchWabaChat();
  }, [dispatch, isHistoryPage, isWhatsappConnected, chatPage, chatLimit, readFilter, dateRange]);

  useEffect(() => { setChatPage(1); }, [readFilter, dateRange]);

  // Replace the onSelect in ChatList and add this effect:

  const handleSelectChat = async (chat) => {
    dispatch(setActiveChat(chat.id));
    dispatch(markChatRead(chat.id));
    setIsLoadingMessages(true);
    const result = await fetchMessages(chat.id, 1);
    if (result) {
      dispatch(setChatMessages({
        chatId: chat.id,
        messages: result.messages,
        pagination: result.pagination,
      }));
    }
    setIsLoadingMessages(false);
  };
  useEffect(() => {
    dispatch(setActiveChat(undefined));
    return () => { dispatch(setActiveChat(undefined)); }; // clear on unmount (navigate away)
  }, [location.pathname, dispatch]);

  // Re-fetch messages when an incoming message triggers a refresh (picks up auto-replies)
  const chatRefreshTrigger = useSelector((s) => s.wabaChat.chatRefreshTrigger);
  const prevRefreshTrigger = useRef({});
  useEffect(() => {
    if (!activeChatId) return;
    const current = chatRefreshTrigger[activeChatId] || 0;
    const prev = prevRefreshTrigger.current[activeChatId] || 0;
    if (current > prev) {
      prevRefreshTrigger.current[activeChatId] = current;
      // Wait for automation/auto-reply to finish saving before re-fetching
      setTimeout(async () => {
        const result = await fetchMessages(activeChatId, 1);
        if (result) {
          dispatch(setChatMessages({ chatId: activeChatId, messages: result.messages, pagination: result.pagination }));
        }
      }, 3000);
    }
  }, [chatRefreshTrigger, activeChatId]); // eslint-disable-line react-hooks/exhaustive-deps

  // Open a specific chat when navigated from the WA toast
  const pendingOpenChatId = useSelector((state) => state.wabaChat.pendingOpenChatId);
  useEffect(() => {
    if (!pendingOpenChatId) return;
    const chat = conversations.find((c) => c.id === pendingOpenChatId || c.from === pendingOpenChatId);
    if (chat) {
      dispatch(clearPendingOpenChat());
      handleSelectChat(chat);
    }
  }, [pendingOpenChatId]); // eslint-disable-line react-hooks/exhaustive-deps


  return (

    <div className="page-wrapper">
      <div className="content h-100">

        {isWhatsappConnected === false ? (

          <div
            style={{
              height: "70vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <h3>WhatsApp is not connected</h3>
            <p style={{ color: "#888", marginBottom: 20 }}>
              Please configure WhatsApp to start chatting.
            </p>


            <button
              className="btn btn-primary"
              onClick={() => {
                if (userProfile?.role === "companyAdmin") {
                  navigate("/whatsapp/setting");
                } else if (userProfile?.role === "superadmin") {
                  navigate("/admin/whatsapp/setting");
                }
              }}
              disabled={userProfile?.role !== "companyAdmin" && userProfile?.role !== "superadmin"}
            >
              {userProfile?.role === "companyAdmin" || userProfile?.role === "superadmin"
                ? "Go to WhatsApp Settings"
                : "Contact your Company Admin"}
            </button>

          </div>

        ) :
          <div className="whatsapp-layout">
            <ChatList
              data={filteredConversations}
              activeId={activeChatId}
              loading={isLoadingChats}
              chatPage={chatPage}
              setChatPage={setChatPage}
              chatLimit={chatLimit}
              setChatLimit={setChatLimit}
              totalCount={totalCount}
              readFilter={readFilter}
              setReadFilter={setReadFilter}
              dateRange={dateRange}
              setDateRange={setDateRange}
              // onSelect={(chat) => dispatch(setActiveChat(chat.id))}
              onSelect={(chat) => handleSelectChat(chat)}
              onNewChat={(contact) => {
                dispatch(startNewChat({
                  name: contact.name,
                  phone: contact.phone,
                  image: contact.image,
                  isWabaChat: contact.isWabaChat
                }))
              }
              }
            />

            <div className={`${activeChat ? "chat-area" : "chat-area-empty"}`}>
              {!showPreview && (
                <ChatWindow
                  conversation={activeChat}
                  onOpenContact={() => dispatch(toggleContact(true))}
                  messagePagination={activePagination}
                  onLoadMore={handleLoadMore}
                  isLoadingMore={isLoadingMoreMessages}
                  isLoadingMessages={isLoadingMessages}
                />
              )}
              {activeChat && <MessageInput
                activeChat={activeChat}
                isWabaChat={activeChat.isWabaChat}
                disabled={!activeChat}
                showPreview={showPreview}
                setShowPreview={setShowPreview}
                onSend={(payload) => {
                  console.log(payload, "payloadddd");

                  if (typeof payload.text === "string") {
                    dispatch(sendMessage({
                      chatId: activeChatId,
                      text: payload.text,
                      name: activeChatName,
                      type: "text",
                      tempId: payload.tempId
                    }));
                  } else {
                    dispatch(sendMessage({
                      chatId: activeChatId,
                      file: payload.file,
                      type: payload.type,
                      name: activeChatName,
                      caption: payload.caption,
                      tempId: payload.tempId
                    }));
                  }
                }} />
              }


            </div>

            {showContact && activeChat && (
              <ContactDetails
                contact={activeChat}
                onClose={() => dispatch(toggleContact(false))}
              />
            )}
          </div>
        }

      </div>
    </div>
  );
};

export default Whatsapp;